import {
  composeValidators,
  nRequired,
  validateDni,
  validatePassword,
} from "../../../helpers/validators";

const loginValidators = {
  identification_number: (value) =>
    composeValidators(nRequired, validateDni)(value),
  password: (value) => validatePassword(value),
};

const validate = (validators, values) => {
  return Object.keys(validators).reduce((acc, key) => {
    const validator = validators[key];

    if (!!validator) {
      acc[key] = validator(values[key]);
    }

    return acc;
  }, {});
};

export const validateLogin = (values: any) => {
  const errors: any = validate(loginValidators, values);
  return errors;
};
